import { ca } from '@cian/analytics';

export function trackTooltipOpen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'Show_sopr',
    label: 'mortgage_discount_label',
    useLastProducts: true,
  });
}
